import { ethers } from "ethers";

 {/* const defaultRPC = [
 'https://polygon-rpc.com/',
 'https://polygon-mainnet.infura.io/',
 'https://polygon-bor-rpc.publicnode.com/' ,
 'https://polygon-mainnet.g.alchemy.com/',
 'https://polygon-mainnet.public.blastapi.io',] */}

// Polygon Mainnet
const defaultRPC = "https://polygon-rpc.com";


// BSC Testnet
// const defaultRPC = "https://data-seed-prebsc-1-s1.binance.org:8545/";

// const defaultRPC = "https://rpc-amoy.polygon.technology";
// const defaultRPC = "https://polygon-amoy-bor-rpc.publicnode.com/";
// const defaultRPC = "https://polygon-rpc.com/";
// const defaultRPC = "https://polygon.llamarpc.com";
// const defaultRPC = "wss://polygon-bor-rpc.publicnode.com";
// const defaultRPC = "https://rpc-mumbai.maticvigil.com/";
// const defaultRPC = "http://127.0.0.1:8545/";

const getProvider = (defaultRpc = false) => {
    if (window.ethereum && !defaultRpc) {
        return new ethers.providers.Web3Provider(window.ethereum);
    }
    return new ethers.providers.JsonRpcProvider(defaultRPC);
};

export default getProvider; 